import React from 'react';
import { List, ListItemText } from '@mui/material';
import { ADD_COMP_GROUP_TYPES } from 'common/constants/comp-groups/compGroups';
import { NewCompDialogProps } from './NewCompDialog.props';
import { StyledDialog, StyledListItem } from './NewCompDialog.styles';

const NewCompDialog = ({ openDialog, handleCompClose, handleApproachTypeClick }: NewCompDialogProps) => (
  <StyledDialog
    onClose={handleCompClose}
    aria-labelledby="comp-group-dialog"
    open={openDialog}
    slotProps={{
      paper: {
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          position: 'fixed',
          zIndex: 3,
          bottom: '2rem',
          right: '1rem',
        },
      },
    }}>
    <List>
      {ADD_COMP_GROUP_TYPES.map(approach => (
        <StyledListItem
          id={`new-comp-dialog-${approach}`}
          button
          onClick={() => handleApproachTypeClick(approach)}
          key={approach}>
          <ListItemText primary={approach} />
        </StyledListItem>
      ))}
    </List>
  </StyledDialog>
);

export default NewCompDialog;
